<template>
  <ul>
      <ol v-for="item in form" :key="item">
          {{ item }}
      </ol>
  </ul>
</template>

<script>
export default {
    props: {
        form: Array
    }
}
</script>

<style>

</style>